import BaseService from "./BaseService";
import IFilter from "../core/contracts/IFilter";
import NotificationModel from "../core/models/Notification";
import NotificationDetailModel from "../core/models/NotificationDetail";
import INotificationReaded from "../core/contracts/INotificationReaded";
import IUserResponse from "../core/contracts/IUserResponse";
import { SessionCache } from "../helpers/cache";

export default class NotificationService extends BaseService {
  async fetchUnRead({ page = 1, pageSize = 8 }): Promise<NotificationModel> {
    try {
      const sessionCache = new SessionCache();
      const user: IUserResponse | null = sessionCache.get("user");

      const filter: IFilter = {
        totalResults: 0,
        pageSize: pageSize,
        page: page,
        orderByField: "createdDate",
        orderByDirection: "Desc",
        userId: user?.id.toString(),
        data: {},
        fields: [
          {
            type: 1,
            field: "Readed",
            argument: "false",
          },
        ],
      };

      const filtroResponse: IFilter = await new BaseService(true).post<IFilter, IFilter>(
        "/core/Notification/filter",
        filter
      );

      const notifications: NotificationModel = {
        totalNotification: filtroResponse.totalResults,
        notifications: filtroResponse.data
          ? (filtroResponse.data as NotificationDetailModel[])
          : undefined,
      };

      return notifications;
    } catch (error) {
      // eslint-disable-next-line no-console
      console.warn("NotificationService -> fetchUnRead -> error", error);
      return Promise.reject(error);
    }
  }

  async setNotificationReaded(notificationReaded: INotificationReaded): Promise<boolean> {
    try {
      return await new BaseService(true).post<boolean, INotificationReaded>(
        "/core/Notification/UpdateNotificationReaded",
        notificationReaded
      );
    } catch (error) {
      // eslint-disable-next-line no-console
      console.warn("NotificationService -> UpdateNotificationReaded -> error", error);
      return Promise.reject(error);
    }
  }
}
